import axios from 'axios';
import { setError } from 'slices/ui/reducer';
import { store } from 'store';
import eventEmitter from './eventEmitter';
// Create a single instance of Axios

const axiosClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  },
});



// Response Interceptor
axiosClient.interceptors.response.use(
  (response) => {
    // You can handle successful responses here if needed
    return response;
  },
  (error) => {
    if (error.response) {
      const { status } = error.response;

      // Check for 401 and redirect to login page
      if (status === 401) {
        // store.dispatch(logout());
      }

      // Check for 403 or 500 errors and dispatch error actions
      let errorMessage = "Something went wrong!";

      switch(status){
        case 403:
          errorMessage = "You are not authorized to perform this action!";
          break;
        case 500:
          errorMessage = "Server error! Please try again later.";
          break;
        case 404:
          errorMessage = "Resource not found!";
          break;
        default:
          errorMessage = "Something went wrong!";
      }

      // Dispatching error to Redux store (assuming error slice has a setError action)
      // store.dispatch(setError({ message: errorMessage, statusCode: status }));
      try {
        eventEmitter.emit('error', {code: status, message: errorMessage});
      } catch (e) {
        console.log(e)
      }
    }

    return Promise.reject(error);
  }
);

export const setAuthorization = (token: string) => {
  // Request Interceptor
  axiosClient.interceptors.request.use(
    (config) => {
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
      }
      const appVersion = localStorage.getItem('brand_app_version');
      if (appVersion) {
        config.headers['AppVersion'] = appVersion;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
}

export default axiosClient;